import React, { useState } from "react";

const ContactModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  // Manejar cambios en los inputs
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Enviar el formulario por email
  const handleSubmit = (e) => {
    e.preventDefault();

    const mailtoLink = `mailto:slowork@slowork.app?subject=Consulta de ${formData.name}&body=Nombre: ${formData.name}%0D%0AEmail: ${formData.email}%0D%0ATeléfono: ${formData.phone}%0D%0A%0D%0AMensaje:%0D%0A${encodeURIComponent(
      formData.message
    )}`;

    window.location.href = mailtoLink;

    setFormData({ name: "", email: "", phone: "", message: "" });
    onClose(); // Cierra el modal
  };

  if (!isOpen) return null; // No renderiza si está cerrado

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-lg w-11/12 max-w-md">
        <h2 className="text-xl font-bold text-primary dark:text-white mb-4 text-center">Contact Us</h2>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          {/* Nombre */}
          <div>
            <label className="block font-semibold dark:text-white">Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="p-3 border rounded-md w-full bg-white text-black dark:bg-gray-800 dark:text-white"
              placeholder="Enter your name"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block font-semibold dark:text-white">Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="p-3 border rounded-md w-full bg-white text-black dark:bg-gray-800 dark:text-white"
              placeholder="Enter your email"
            />
          </div>

          {/* Teléfono */}
          <div>
            <label className="block font-semibold dark:text-white">Phone:</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              className="p-3 border rounded-md w-full bg-white text-black dark:bg-gray-800 dark:text-white"
              placeholder="Enter your phone number"
            />
          </div>

          {/* Mensaje */}
          <div>
            <label className="block font-semibold dark:text-white">Message:</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              className="p-3 border rounded-md w-full bg-white text-black dark:bg-gray-800 dark:text-white"
              rows="4"
              placeholder="Write your message..."
            />
          </div>

          {/* Botones */}
          <div className="flex justify-between mt-4">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-300 hover:bg-gray-400 text-black py-2 px-4 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-primary hover:bg-secondary text-white py-2 px-4 rounded"
            >
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;
